import React, {useCallback, useContext, useEffect, useRef} from 'react';

import {BroadcastContext} from 'src/contexts/brodcast-context';
import {AUTH_CALLBACK_EVENTS} from
    'src/modules/profile/account/tabs/license-and-features/crm-tab/constants';

import Loading from '@pb/kit-component-loading';

import {useSaveMsDynamicsAuth} from './useSaveMSDynamicsAuth';

export const MsDynamicsOauthCallback = () => {
    const {sendMessage} = useContext(BroadcastContext);
    const isProcessed = useRef(false);

    const broadcastAndClose = useCallback(
        (result: {success: boolean, error?: string}) => {
            sendMessage(JSON.stringify({
                [AUTH_CALLBACK_EVENTS.MS_DYNAMICS]: result,
            }));
            window.close();
        },
        [sendMessage],
    );

    const {
        isLoading: isSaveBusy,
        action: saveMsDynamicsAuthCredentials,
    } = useSaveMsDynamicsAuth({
        onSuccess: () => broadcastAndClose({success: true}),
        onFailure: error => broadcastAndClose({success: false, error}),
    });

    useEffect(() => {
        if (isProcessed.current) {
            return;
        }

        const authorizationCode = window.location.href;
        if (authorizationCode) {
            isProcessed.current = true;
            saveMsDynamicsAuthCredentials({authorizationCode});
        }
    }, [saveMsDynamicsAuthCredentials]);

    return isSaveBusy ? <Loading fast={true}/> : null;
};
